export enum AnnexSyncStatusEnum {
  Pending = 1,
  InProcess = 2,
  Success = 3,
  Error = 4,
}
